<template>
  <banners
    :sticky-top="true"
    :narrow="true"
  >
    <div class="container-max mx-auto w-full px-4 py-6 text-left md:px-10">
      <p class="header-text mb-8 text-dark-blue">Account Overview</p>
      <show-profile />
    </div>
  </banners>
</template>

<script type="text/javascript">
import Banners from '@/components/Banners.vue';
import ShowProfile from '@/views/common/my-profile/ShowProfile.vue';

export default {
  name: 'Carrier My Profile',
  components: {
    Banners,
    ShowProfile,
  },
  beforeMount() {
    this.$store.dispatch(
      'ownership/getOwnershipByCompanyId',
      this.$store.state.users.currentUser?.company?.id
    );
  },
};
</script>

<style scoped>
.header-text {
  font-size: 26px;
}
</style>
